import { Component } from 'react';

class GradientSVG extends Component<{
	startColor: string;
	endColor: string;
	idCSS: string;
	rotation: number;
	gradientTransform: string;
	linearGradientOptions: {
		x1: number;
		y1: number;
		x2: number;
		y2: number;
	};
}> {
	render() {
		const { startColor, endColor, idCSS, gradientTransform, linearGradientOptions } = this.props;

		return (
			<svg style={{ height: 0 }}>
				<defs>
					<linearGradient id={idCSS} gradientUnits={gradientTransform} {...linearGradientOptions}>
						<stop stopColor={startColor} />
						<stop offset="1" stopColor={endColor} />
					</linearGradient>
				</defs>
			</svg>
		);
	}
}

export default GradientSVG;
